import crypto from "crypto"
import jwt from "jsonwebtoken"

import { SECRET_KEY } from "#constants"
import executeQuery from "#lib/db"

interface UserLogin {
	userID: string
	password: string
}

const getUser = async ({ userID, password }: UserLogin) => {
	const encryptedPassword = crypto.createHash("sha256").update(password).digest("hex")

	console.log("userID:", userID, "\n\n", "encrypted password:", encryptedPassword)

	const query = `select * from users where email='${userID}' and password='${encryptedPassword}'`

	const user = await executeQuery({
		query,
	})

	if (user.length === 0) {
		// no user found
		return null
	} else {
		const {
			userID,
			canViewCost,
			canViewSources,
			canViewAQAdvisor,
			canViewQuarantine,
			canViewEnvironmental,
			canViewFuture,
			displayName,
		} = user[0]

		const token = jwt.sign(
			{
				userID,
				canViewCost,
				canViewSources,
				canViewAQAdvisor,
				canViewQuarantine,
				canViewEnvironmental,
				canViewFuture,
			},
			SECRET_KEY,
		)

		return {
			userID,
			canViewCost,
			canViewSources,
			canViewAQAdvisor,
			canViewQuarantine,
			canViewEnvironmental,
			canViewFuture,
			displayName,
			token,
		}
	}
}

export default getUser
